<template>
    <PopupRouterViewDetail label="Repacking Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Repacking" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
					<app-label label-cols-lg="12" size="sm" type="generatednumber" label="Repacking No" :model="model.repackingNo" />
					<app-input-combobox-autocomplete :options="deliveryInstructions" optionsLabel="diNumber" optionsKey="id" label-cols-lg="12" label="Delivery Instruction" id="fieldset-delivery-instruction" size="sm" :model.sync="model.deliveryInstructionId"   :selected="model.deliveryInstruction != null ? model.deliveryInstruction.diNumber : ''" @input="getDeliveryInstructions" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedDeliveryInstruction" />
					<app-input-datepicker  id="fieldset-repack-date" label-cols-lg="12"  label="Repack Date" size="sm" :model.sync="model.repackDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="false" :isEditable="false" />
					<app-input-datepicker  id="fieldset-delivery-date" label-cols-lg="12"  label="Delivery Date" size="sm" :model.sync="model.deliveryDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="false" :isEditable="false" />
					<app-input-combobox-autocomplete :options="repackStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="Repack Status" id="fieldset-repack-status" size="sm" :model.sync="model.repackStatusId"   :selected="model.repackStatus != null ? model.repackStatus.name : ''" @input="getRepackStatuss" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedRepackStatus" />
				</b-col>
				<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="Repack By" id="fieldset-repack-by" size="sm" :model.sync="model.repackByUserName"   :selected="model.repackBy != null ? model.repackBy.firstName : ''" @input="getUserInfos" @change="updateData"  :isUpdatable="false" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedRepackBy" />
					<app-input-datetimepicker id="fieldset-start-date" label-cols-lg="12"  label="Start Date" size="sm" :model.sync="model.startDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="false" :isEditable="false" />
					<app-input-datetimepicker id="fieldset-finish-date" label-cols-lg="12"  label="Finish Date" size="sm" :model.sync="model.finishDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData"  :isUpdatable="false" :isEditable="false" />
					<app-input-textbox id="fieldset-po-no-customer" label-cols-lg="12"  label="PO No Customer" label-for="input-po-no-customer" size="sm" :model.sync="model.poNoCustomer"  @change="updateData"  :isUpdatable="false" :isEditable="false" />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Repacking Detail" :bordered="true" :items="repackingDetails" :fields="fieldsRepackingDetail" :busy="isDataLoading" :sort-by.sync="sortByRepackingDetail" :sort-desc.sync="sortDescRepackingDetail" small responsive
			@editButtonMethod="editRowDataRepackingDetail"
			@deleteButtonMethod="deleteRowDataRepackingDetail"
			@showPopupAddMethod="resetDataRepackingDetail()"
			@showPopupUploadMethod="showPopupUploadRepackingDetail()"
			@downloadMethod="downloadRepackingDetail()"
			@addFromClipboardMethod="addFromClipboardRepackingDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardRepackingDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadRepackingDetail"
			>
			<template #top-row v-if="isShowRepackingDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Delivery Instruction Detail">
					<v-select append-to-body label="part" :options="deliveryInstructionDetails"  :value="filterRepackingDetail.deliveryInstructionDetailId" :reduce="item => item.id" v-model="filterRepackingDetail.deliveryInstructionDetailId" @search="getDeliveryInstructionDetails" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterRepackingDetail.partId" :reduce="item => item.id" v-model="filterRepackingDetail.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Repack Status">
					<v-select append-to-body label="name" :options="repackStatuss"  :value="filterRepackingDetail.repackStatusId" :reduce="item => item.id" v-model="filterRepackingDetail.repackStatusId" @search="getRepackStatuss" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Repack By">
					<v-select append-to-body label="firstName" :options="userInfos"  :value="filterRepackingDetail.repackById" :reduce="item => item.id" v-model="filterRepackingDetail.repackById" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Start Date">
					<app-input-datetimepicker-range id="fieldset-start-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Start Date" size="sm" :modelFrom.sync="filterRepackingDetail.startDateFrom" :modelTo.sync="filterRepackingDetail.startDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
				</b-th>
				<b-th stacked-heading="Finish Date">
					<app-input-datetimepicker-range id="fieldset-finish-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Finish Date" size="sm" :modelFrom.sync="filterRepackingDetail.finishDateFrom" :modelTo.sync="filterRepackingDetail.finishDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
				</b-th>
				<b-th stacked-heading="Qty Repack">
					<b-form-input id="input-qty-repack-table" v-model="filterRepackingDetail.qtyRepack" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Outstanding">
					<b-form-input id="input-qty-outstanding-table" v-model="filterRepackingDetail.qtyOutstanding" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Fullfiled">
					<b-form-input id="input-qty-fullfiled-table" v-model="filterRepackingDetail.qtyFullfiled" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( repackingDetailPageSize * (currentRepackingDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<!-- <template v-slot:cell(deliveryInstructionDetail)="row">
				<app-input-combobox-autocomplete :options="deliveryInstructionDetails" optionsLabel="part" optionsKey="id" :id="'input-repacking-detail-delivery-instruction-detail-' + row.index" label-cols-lg="12" label="Delivery Instruction Detail" size="sm" :model.sync="row.item.deliveryInstructionDetailId" :state="validateState('deliveryInstructionDetailId')" :errorMessage="getErrorMessage(errorMessage.deliveryInstructionDetailId, 'deliveryInstructionDetailId')"  @change="saveInputRepackingDetail(row.item)" :selected="row.item.deliveryInstructionDetail != null ? row.item.deliveryInstructionDetail.part != null ? row.item.deliveryInstructionDetail.part.partName : '' : ''"  @input="getDeliveryInstructionDetails" :loading="isDeliveryInstructionDetailComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template> -->
			<template v-slot:cell(partNumber)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-repacking-detail-part-number-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputRepackingDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partName" optionsKey="id" :id="'input-repacking-detail-part-name-' + row.index" label-cols-lg="12" label="Part Name" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputRepackingDetail(row.item)" :selected="row.item.part != null ? row.item.part.partName : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(repackStatus)="row">
				<app-input-combobox-autocomplete :options="repackStatuss" optionsLabel="name" optionsKey="id" :id="'input-repacking-detail-repack-status-' + row.index" label-cols-lg="12" label="Repack Status" size="sm" :model.sync="row.item.repackStatusId" :state="validateState('repackStatusId')" :errorMessage="getErrorMessage(errorMessage.repackStatusId, 'repackStatusId')"  @change="saveInputRepackingDetail(row.item)" :selected="row.item.repackStatus != null ? row.item.repackStatus.name : ''"  @input="getRepackStatuss" :loading="isRepackStatusComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(repackBy)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-repacking-detail-repack-by-' + row.index" label-cols-lg="12" label="Repack By" size="sm" :model.sync="row.item.repackById"  @change="saveInputRepackingDetail(row.item)" :selected="row.item.repackBy != null ? row.item.repackBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(startDate)="row">
				<app-input-datetimepicker :id="'input-repacking-detail-start-date-' + row.index" label-cols-lg="12" label="Start Date" size="sm" :model.sync="row.item.startDate"   @change="saveInputRepackingDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(finishDate)="row">
				<app-input-datetimepicker :id="'input-repacking-detail-finish-date-' + row.index" label-cols-lg="12" label="Finish Date" size="sm" :model.sync="row.item.finishDate"   @change="saveInputRepackingDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyRepack)="row">
				<app-input-textbox :id="'input-repacking-detail-qty-repack-' + row.index" label-cols-lg="12" label="Qty Repack" size="sm" :model.sync="row.item.qtyRepack"   @change="saveInputRepackingDetail(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyOutstanding)="row">
				<app-input-textbox :id="'input-repacking-detail-qty-outstanding-' + row.index" label-cols-lg="12" label="Qty Outstanding" size="sm" :model.sync="row.item.qtyOutstanding"   @change="saveInputRepackingDetail(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyFullfiled)="row">
				<app-input-textbox :id="'input-repacking-detail-qty-fullfiled-' + row.index" label-cols-lg="12" label="Qty Fullfiled" size="sm" :model.sync="row.item.qtyFullfiled"   @change="saveInputRepackingDetail(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<RepackingDetailInput 
					:openPopup="isShowPopupRepackingDetail"
					:modelId="repackingDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataRepackingDetail"/>
			</template>
			<template v-slot:upload-detail>
				<RepackingDetailUpload
					:openPopup="isShowPopupUploadRepackingDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataRepackingDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-repacking-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId" :state="validateState('partId')" :errorMessage="getErrorMessage(errorMessage.partId, 'partId')"  @change="saveInputRepackingDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="repackStatuss" optionsLabel="name" optionsKey="id" :id="'input-repacking-detail-repack-status-' + row.index" label-cols-lg="12" label="Repack Status" size="sm" :model.sync="row.item.repackStatusId" :state="validateState('repackStatusId')" :errorMessage="getErrorMessage(errorMessage.repackStatusId, 'repackStatusId')"  @change="saveInputRepackingDetail(row.item)" :selected="row.item.repackStatus != null ? row.item.repackStatus.name : ''"  @input="getRepackStatuss" :loading="isRepackStatusComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-repacking-detail-repack-by-' + row.index" label-cols-lg="12" label="Repack By" size="sm" :model.sync="row.item.repackById"  @change="saveInputRepackingDetail(row.item)" :selected="row.item.repackBy != null ? row.item.repackBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-datetimepicker :id="'input-repacking-detail-start-date-' + row.index" label-cols-lg="12" label="Start Date" size="sm" :model.sync="row.item.startDate"   @change="saveInputRepackingDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isUpdatable="false" :isEditable="false"  />
					<app-input-datetimepicker :id="'input-repacking-detail-finish-date-' + row.index" label-cols-lg="12" label="Finish Date" size="sm" :model.sync="row.item.finishDate"   @change="saveInputRepackingDetail(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-repacking-detail-qty-repack-' + row.index" label-cols-lg="12" label="Qty Repack" size="sm" :model.sync="row.item.qtyRepack"   @change="saveInputRepackingDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-repacking-detail-qty-outstanding-' + row.index" label-cols-lg="12" label="Qty Outstanding" size="sm" :model.sync="row.item.qtyOutstanding"   @change="saveInputRepackingDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-repacking-detail-qty-fullfiled-' + row.index" label-cols-lg="12" label="Qty Fullfiled" size="sm" :model.sync="row.item.qtyFullfiled"   @change="saveInputRepackingDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
		<app-table-input-popup title="Repacking Control Card" :bordered="true" :items="repackingControlCards" :fields="fieldsRepackingControlCard" :busy="isDataLoading" :sort-by.sync="sortByRepackingControlCard" :sort-desc.sync="sortDescRepackingControlCard" small responsive
			@editButtonMethod="editRowDataRepackingControlCard"
			@deleteButtonMethod="deleteRowDataRepackingControlCard"
			@showPopupAddMethod="resetDataRepackingControlCard()"
			@showPopupUploadMethod="showPopupUploadRepackingControlCard()"
			@downloadMethod="downloadRepackingControlCard()"
			@addFromClipboardMethod="addFromClipboardRepackingControlCard()"
			@replaceFromClipboardMethod="replaceFromClipboardRepackingControlCard()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadRepackingControlCard"
			>
			<template #top-row v-if="isShowRepackingControlCardFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Repacking Detail">
					<v-select append-to-body label="deliveryInstructionDetail" :options="repackingDetails"  :value="filterRepackingControlCard.repackingDetailId" :reduce="item => item.id" v-model="filterRepackingControlCard.repackingDetailId" @search="getRepackingDetails" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Control Card">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterRepackingControlCard.controlCardId" :reduce="item => item.id" v-model="filterRepackingControlCard.controlCardId" @search="getControlCards" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Scan By">
					<v-select append-to-body label="firstName" :options="userInfos"  :value="filterRepackingControlCard.scanById" :reduce="item => item.id" v-model="filterRepackingControlCard.scanById" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Scan Date">
					<app-input-datetimepicker-range id="fieldset-scan-date" label-cols-sm="4" label-cols-lg="3" :nolabel="true" label="Scan Date" size="sm" :modelFrom.sync="filterRepackingControlCard.scanDateFrom" :modelTo.sync="filterRepackingControlCard.scanDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button/>
				</b-th>
				<b-th stacked-heading="Qty">
					<b-form-input id="input-qty-table" v-model="filterRepackingControlCard.qty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Qty Original">
					<b-form-input id="input-qty-original-table" v-model="filterRepackingControlCard.qtyOriginal" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( repackingControlCardPageSize * (currentRepackingControlCardPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(repackingDetail)="row">
				<app-input-combobox-autocomplete :options="repackingDetails" optionsLabel="deliveryInstructionDetail" optionsKey="id" :id="'input-repacking-control-card-repacking-detail-' + row.index" label-cols-lg="12" label="Repacking Detail" size="sm" :model.sync="row.item.repackingDetailId"  @change="saveInputRepackingControlCard(row.item)" :selected="row.item.repackingDetail != null ? row.item.repackingDetail.deliveryInstructionDetail : ''"  @input="getRepackingDetails" :loading="isRepackingDetailComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(controlCard)="row">
				<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-repacking-control-card-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputRepackingControlCard(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(scanBy)="row">
				<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-repacking-control-card-scan-by-' + row.index" label-cols-lg="12" label="Scan By" size="sm" :model.sync="row.item.scanById"  @change="saveInputRepackingControlCard(row.item)" :selected="row.item.scanBy != null ? row.item.scanBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"   :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(scanDate)="row">
				<!-- <app-input-datetimepicker :id="'input-repacking-control-card-scan-date-' + row.index" label-cols-lg="12" label="Scan Date" size="sm" :model.sync="row.item.scanDate"   @change="saveInputRepackingControlCard(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isUpdatable="false" :isEditable="false"   :nolabel="true" /> -->
				{{ formatDate(row.item.scanDate) }}
			</template>
			<template v-slot:cell(qty)="row">
				<app-input-textbox :id="'input-repacking-control-card-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputRepackingControlCard(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(qtyOriginal)="row">
				<app-input-textbox :id="'input-repacking-control-card-qty-original-' + row.index" label-cols-lg="12" label="Qty Original" size="sm" :model.sync="row.item.qtyOriginal"   @change="saveInputRepackingControlCard(row.item)"  :isUpdatable="false" :isEditable="false"   :nolabel="true" />
			</template>

			<template v-slot:form-add-detail>
				<RepackingControlCardInput 
					:openPopup="isShowPopupRepackingControlCard"
					:modelId="repackingControlCardId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataRepackingControlCard"/>
			</template>
			<template v-slot:upload-detail>
				<RepackingControlCardUpload
					:openPopup="isShowPopupUploadRepackingControlCard"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataRepackingControlCard"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-repacking-control-card-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputRepackingControlCard(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" :id="'input-repacking-control-card-scan-by-' + row.index" label-cols-lg="12" label="Scan By" size="sm" :model.sync="row.item.scanById"  @change="saveInputRepackingControlCard(row.item)" :selected="row.item.scanBy != null ? row.item.scanBy.firstName : ''"  @input="getUserInfos" :loading="isUserInfoComboLoading"  :isUpdatable="false" :isEditable="false"  />
					<app-input-datetimepicker :id="'input-repacking-control-card-scan-date-' + row.index" label-cols-lg="12" label="Scan Date" size="sm" :model.sync="row.item.scanDate"   @change="saveInputRepackingControlCard(row.item)" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-repacking-control-card-qty-' + row.index" label-cols-lg="12" label="Qty" size="sm" :model.sync="row.item.qty"   @change="saveInputRepackingControlCard(row.item)" :isUpdatable="false" :isEditable="false"  />
					<app-input-textbox :id="'input-repacking-control-card-qty-original-' + row.index" label-cols-lg="12" label="Qty Original" size="sm" :model.sync="row.item.qtyOriginal"   @change="saveInputRepackingControlCard(row.item)" :isUpdatable="false" :isEditable="false"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import Repacking from '@/models/Repacking/Repacking';
import RepackingList from '@/models/Repacking/RepackingList';
import RepackingFilter from '@/filters/Repacking/RepackingFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import DeliveryInstruction from '@/models/DeliveryInstruction/DeliveryInstruction';
import DeliveryInstructionFilter from '@/filters/DeliveryInstruction/DeliveryInstructionFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import RepackStatus from '@/models/RepackStatus/RepackStatus';
import RepackStatusFilter from '@/filters/RepackStatus/RepackStatusFilter';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
import AppInputTextbox from '@/components/AppInputTextbox';
import RepackingDetail from '@/models/Repacking/RepackingDetail';
import RepackingDetailFilter from '@/filters/Repacking/RepackingDetailFilter';
import RepackingControlCard from '@/models/Repacking/RepackingControlCard';
import RepackingControlCardFilter from '@/filters/Repacking/RepackingControlCardFilter';
import DeliveryInstructionDetail from '@/models/DeliveryInstruction/DeliveryInstructionDetail';
import DeliveryInstructionDetailFilter from '@/filters/DeliveryInstruction/DeliveryInstructionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import RepackingDetailInput from '@/views/Repacking/RepackingDetailInput';
import RepackingDetailUpload from '@/views/Repacking/RepackingDetailUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import RepackingControlCardInput from '@/views/Repacking/RepackingControlCardInput';
import RepackingControlCardUpload from '@/views/Repacking/RepackingControlCardUpload';
import PopupRouterView from '@/components/PopupRouterView';
import moment from 'moment';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputDatetimepicker,
		AppInputDatetimepickerRange,
		AppInputTextbox,
		RepackingDetailInput,RepackingDetailUpload,
		RepackingControlCardInput,RepackingControlCardUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsRepackingDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				// {"deliveryInstructionDetail": { "class" : "th-delivery-instruction-detail first-child", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetail', sortable: false}}, 
				{"partNumber": { "class" : "th-part-number", "label" : "Part Number", key: 'partNumber', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				//{"repackStatus": { "class" : "th-repack-status last-child", "label" : "Repack Status", key: 'repackStatus', sortable: false}}, 
				//{"repackBy": { "class" : "th-repack-by d-stack-none", "label" : "Repack By", key: 'repackBy', sortable: false}}, 
				//{"startDate": { "class" : "th-start-date d-stack-none", "label" : "Start Date", key: 'startDate', sortable: false}}, 
				//{"finishDate": { "class" : "th-finish-date d-stack-none", "label" : "Finish Date", key: 'finishDate', sortable: false}}, 
				{"qtyRepack": { "class" : "th-qty-repack d-stack-none", "label" : "Qty Repack", key: 'qtyRepack', sortable: false}}, 
				{"qtyOutstanding": { "class" : "th-qty-outstanding d-stack-none", "label" : "Qty Outstanding", key: 'qtyOutstanding', sortable: false}}, 
				{"qtyFullfiled": { "class" : "th-qty-fullfiled d-stack-none", "label" : "Qty Fullfiled", key: 'qtyFullfiled', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			fieldsRepackingControlCard: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				// {"repackingDetail": { "class" : "th-repacking-detail first-child", "label" : "Repacking Detail", key: 'repackingDetail', sortable: false}}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Control Card", key: 'controlCard', sortable: false}}, 
				{"scanBy": { "class" : "th-scan-by last-child", "label" : "Scan By", key: 'scanBy', sortable: false}}, 
				{"scanDate": { "class" : "th-scan-date d-stack-none", "label" : "Scan Date", key: 'scanDate', sortable: false}}, 
				{"qty": { "class" : "th-qty d-stack-none", "label" : "Qty", key: 'qty', sortable: false}}, 
				{"qtyOriginal": { "class" : "th-qty-original d-stack-none", "label" : "Qty Original", key: 'qtyOriginal', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelRepackingDetail : {},
			isShowPopupRepackingDetail : false,
			isShowPopupUploadRepackingDetail : false,
			modelRepackingControlCard : {},
			isShowPopupRepackingControlCard : false,
			isShowPopupUploadRepackingControlCard : false,
			filterRepacking : null,
			currentRepackingPage : 1,
			repackingPageSize: 10,
			sortByRepacking: '',
			sortDescRepacking: '',
			filterRepackingDetail : null,
			currentRepackingDetailPage : 1,
			repackingDetailPageSize: 10,
			sortByRepackingDetail: '',
			sortDescRepackingDetail: '',
			sortingByRepackingDetail: [],
			repackingDetails : [],
			repackingDetailId : '',
			totalRepackingDetailRow : 0,
			isShowRepackingDetailFilter: false,
			isDownloadRepackingDetail: false,
			filterRepackingControlCard : null,
			currentRepackingControlCardPage : 1,
			repackingControlCardPageSize: 10,
			sortByRepackingControlCard: '',
			sortDescRepackingControlCard: '',
			sortingByRepackingControlCard: [],
			repackingControlCards : [],
			repackingControlCardId : '',
			totalRepackingControlCardRow : 0,
			isShowRepackingControlCardFilter: false,
			isDownloadRepackingControlCard: false,
			deliveryInstructionDetails: [],
			parts: [],
			repackStatuss: [],
			userInfos: [],
			controlCards: [],
			deliveryInstructions: [],
			isDeliveryInstructionComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isRepackStatusComboLoading: false,
			isUserInfoComboLoading: false,
			isRepackingComboLoading: false,
			isDeliveryInstructionDetailComboLoading: false,
			isPartComboLoading: false,
			isRepackingDetailComboLoading: false,
			isControlCardComboLoading: false,
		}
	},
	methods : {
		formatDate(date) {
			return moment(date).format('DD-MM-YYYY HH:mm')
		},
		getRepacking : async function(id) {
			this.isBusy = true;
			Repacking.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadRepacking = true;
			this.filterRepacking.id = this.modelId;
			Repacking.downloadDataDetail(this, this.filterRepacking).then(result => {
				this.isDownloadRepacking = false;
			}).catch(error => { this.isDownloadRepacking = false; })
		},
		// getRepackingDetails : async function(isAddRow) {
		// 	let filter = {};
		// 	Object.assign(filter, this.filterRepackingDetail);
		// 	if (this.modelId == null) return;
		// 	filter.repackingId = this.modelId;
		// 	filter.draftMode = "0";
		// 	if (this.sortByRepackingDetail != null) {
		// 		this.sortingByRepackingDetail[this.sortByRepackingDetail] = this.sortDescRepackingDetail;
		// 	}
		// 	let currentPage = (this.currentRepackingDetailPage - 1);
		// 	if (isAddRow) {
		// 		let totalData = this.totalRepackingDetailRow + 1;
		// 		let page = Math.ceil(totalData/this.repackingDetailPageSize);
		// 		currentPage = page - 1;
		// 	}
		// 	// disable paging start
		// 	currentPage = null;
		// 	this.repackingDetailPageSize = 0;
		// 	// disable paging end
		// 	RepackingDetail.getList(this, filter, this.sortingByRepackingDetail, currentPage , this.repackingDetailPageSize).then(result => {
		// 		this.currentRepackingDetailPage = currentPage + 1;
		// 		this.repackingDetails = result.data;
		// 		this.totalRepackingDetailRow = result.dataCount;
		// 	}).catch(error => {});
		// },
		getRepackingControlCards : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterRepackingControlCard);
			if (this.modelId == null) return;
			filter.repackingId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByRepackingControlCard != null) {
				this.sortingByRepackingControlCard[this.sortByRepackingControlCard] = this.sortDescRepackingControlCard;
			}
			let currentPage = (this.currentRepackingControlCardPage - 1);
			if (isAddRow) {
				let totalData = this.totalRepackingControlCardRow + 1;
				let page = Math.ceil(totalData/this.repackingControlCardPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.repackingControlCardPageSize = 0;
			// disable paging end
			RepackingControlCard.getList(this, filter, this.sortingByRepackingControlCard, currentPage , this.repackingControlCardPageSize).then(result => {
				this.currentRepackingControlCardPage = currentPage + 1;
				this.repackingControlCards = result.data;
				this.totalRepackingControlCardRow = result.dataCount;
			}).catch(error => {});
		},
		getRepackings : async function(input) {
			let filter = new RepackingFilter();
			if (input != undefined) {
				filter.RepackingNo = input;
			}
			this.isRepackingComboLoading = true;
			Repacking.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.repackings = result.data
				}
				this.isRepackingComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructionDetails : async function(input) {
			let filter = new DeliveryInstructionDetailFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isDeliveryInstructionDetailComboLoading = true;
			DeliveryInstructionDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructionDetails = result.data
				}
				this.isDeliveryInstructionDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getRepackStatuss : async function(input) {
			let filter = new RepackStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isRepackStatusComboLoading = true;
			RepackStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.repackStatuss = result.data
				}
				this.isRepackStatusComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
				this.isUserInfoComboLoading = false;
			})
			.catch(error => {});
		},
		getRepackingDetails : async function(input) {
			let filter = new RepackingDetailFilter();
			if (input != undefined) {
				filter.deliveryInstructionDetail = input;
			}
			if (this.modelId == null) return;
			filter.repackingId = this.modelId;
			filter.draftMode = "0";
			this.isRepackingDetailComboLoading = true;
			RepackingDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.repackingDetails = result.data
				}
				this.isRepackingDetailComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getDeliveryInstructions : async function(input) {
			let filter = new DeliveryInstructionFilter();
			if (input != undefined) {
				filter.diNumber = input;
			}
			DeliveryInstruction.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.deliveryInstructions = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedDeliveryInstruction(item) {
			if(item == undefined || item == null) {
				this.model.deliveryInstructionId = null;
				this.model.deliveryInstruction = null;
			} else {
				this.model.deliveryInstructionId = item.id;
				this.model.deliveryInstruction = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedRepackStatus(item) {
			if(item == undefined || item == null) {
				this.model.repackStatusId = null;
				this.model.repackStatus = null;
			} else {
				this.model.repackStatusId = item.id;
				this.model.repackStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedRepackBy(item) {
			if(item == undefined || item == null) {
				this.model.repackByUserName = null;
				this.model.repackBy = null;
			} else {
				this.model.repackByUserName = item.userName;
				this.model.repackBy = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.repackingInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					Repacking.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'repackingindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					Repacking.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'repackingindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					Repacking.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getRepacking(id);
					});
				}
			});
		},
		onHidden() {
			this.getRepackings();
		},
		addRowDataRepackingDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.repackingId =  this.modelId;
					RepackingDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getRepackingDetails(true);
						this.isShowPopupRepackingDetail = false;
					})
				} else {
					model.repackingId =  this.modelId;
					RepackingDetail.createDataDetail(this, model)
					.then(result => {
						this.getRepackingDetails(true);
						this.isShowPopupRepackingDetail = false;
					})
				}
			}
		},
		async editRowDataRepackingDetail(id) {
			this.repackingDetailId = id;
			this.isShowPopupRepackingDetail = true; 
		},
		async deleteRowDataRepackingDetail(id) {
			RepackingDetail.deleteData(this, id).then(result => { this.getRepackingDetails(); });
		},
		async resetDataRepackingDetail() {
			this.repackingDetailId = "";
			this.isShowPopupRepackingDetail = true;
		},
		async addDataRepackingDetail() {
			RepackingDetail.createData(this, { repackingId: this.modelId })
			.then(result => {
				this.getRepackingDetails(true);
			})
		},
		async addFromClipboardRepackingDetail() {
			let deliveryInstructionDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryInstructionDetails.push({ deliveryInstructionDetail: item, repackingId: this.modelId });
				});
				RepackingDetail.addFromClipboard(this, deliveryInstructionDetails).then(result => { this.getRepackingDetails() });
			});
		},
		async replaceFromClipboardRepackingDetail() {
			let deliveryInstructionDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					deliveryInstructionDetails.push({ deliveryInstructionDetail: item, repackingId: this.modelId });
				});
				RepackingDetail.replaceFromClipboard(this, deliveryInstructionDetails).then(result => { this.getRepackingDetails() });
			});   
		},
		showPopupUploadRepackingDetail() {
			if(this.repackingDetails != null && this.repackingDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap RepackingDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadRepackingDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadRepackingDetail = true;
			}
		},
		uploadDataRepackingDetail(modalEvent, newDatas) {
			this.isShowPopupUploadRepackingDetail = false; 
		},
		downloadRepackingDetail(modalEvent) {
			this.isDownloadRepackingDetail = true;
			this.filterRepackingDetail.repackingId = this.modelId;
			RepackingDetail.downloadDataDetail(this, this.filterRepackingDetail).then(result => {
				this.isDownloadRepackingDetail = false;
			}).catch(error => { this.isDownloadRepackingDetail = false; })
		},
		saveInputRepackingDetail(item) {
			if (this.repackings != null && this.repackings != undefined  && this.repackings.length > 0) {
				item.repacking = this.repackings.find(q => q.id == item.repackingId);
			}
			if (this.deliveryInstructionDetails != null && this.deliveryInstructionDetails != undefined  && this.deliveryInstructionDetails.length > 0) {
				item.deliveryInstructionDetail = this.deliveryInstructionDetails.find(q => q.id == item.deliveryInstructionDetailId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.repackStatuss != null && this.repackStatuss != undefined  && this.repackStatuss.length > 0) {
				item.repackStatus = this.repackStatuss.find(q => q.id == item.repackStatusId);
			}
			if (this.userInfos != null && this.userInfos != undefined  && this.userInfos.length > 0) {
				item.repackBy = this.userInfos.find(q => q.id == item.repackByUserName);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					RepackingDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		addRowDataRepackingControlCard(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.repackingId =  this.modelId;
					RepackingControlCard.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getRepackingControlCards(true);
						this.isShowPopupRepackingControlCard = false;
					})
				} else {
					model.repackingId =  this.modelId;
					RepackingControlCard.createDataDetail(this, model)
					.then(result => {
						this.getRepackingControlCards(true);
						this.isShowPopupRepackingControlCard = false;
					})
				}
			}
		},
		async editRowDataRepackingControlCard(id) {
			this.repackingControlCardId = id;
			this.isShowPopupRepackingControlCard = true; 
		},
		async deleteRowDataRepackingControlCard(id) {
			RepackingControlCard.deleteData(this, id).then(result => { this.getRepackingControlCards(); });
		},
		async resetDataRepackingControlCard() {
			this.repackingControlCardId = "";
			this.isShowPopupRepackingControlCard = true;
		},
		async addDataRepackingControlCard() {
			RepackingControlCard.createData(this, { repackingId: this.modelId })
			.then(result => {
				this.getRepackingControlCards(true);
			})
		},
		async addFromClipboardRepackingControlCard() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, repackingId: this.modelId });
				});
				RepackingControlCard.addFromClipboard(this, controlCards).then(result => { this.getRepackingControlCards() });
			});
		},
		async replaceFromClipboardRepackingControlCard() {
			let controlCards = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					controlCards.push({ controlCard: item, repackingId: this.modelId });
				});
				RepackingControlCard.replaceFromClipboard(this, controlCards).then(result => { this.getRepackingControlCards() });
			});   
		},
		showPopupUploadRepackingControlCard() {
			if(this.repackingControlCards != null && this.repackingControlCards.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap RepackingControlCard akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadRepackingControlCard = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadRepackingControlCard = true;
			}
		},
		uploadDataRepackingControlCard(modalEvent, newDatas) {
			this.isShowPopupUploadRepackingControlCard = false; 
		},
		downloadRepackingControlCard(modalEvent) {
			this.isDownloadRepackingControlCard = true;
			this.filterRepackingControlCard.repackingId = this.modelId;
			RepackingControlCard.downloadDataDetail(this, this.filterRepackingControlCard).then(result => {
				this.isDownloadRepackingControlCard = false;
			}).catch(error => { this.isDownloadRepackingControlCard = false; })
		},
		saveInputRepackingControlCard(item) {
			if (this.repackingDetails != null && this.repackingDetails != undefined  && this.repackingDetails.length > 0) {
				item.repackingDetail = this.repackingDetails.find(q => q.id == item.repackingDetailId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					RepackingControlCard.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadRepackingDetail = false; 
			this.isShowPopupRepackingDetail = false; 
			if (modalType == 'RepackingDetail') {
				this.getRepackingDetails();
			}
			this.isShowPopupUploadRepackingControlCard = false; 
			this.isShowPopupRepackingControlCard = false; 
			if (modalType == 'RepackingControlCard') {
				this.getRepackingControlCards();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowRepackingDetailFilter = true;
				//this.isShowRepackingControlCardFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterRepacking = new RepackingFilter();
		this.filterRepackingDetail = new RepackingDetailFilter();
		this.filterRepackingControlCard = new RepackingControlCardFilter();
		//this.getRepackings();
		//this.getDeliveryInstructionDetails();
		//this.getParts();
		//this.getRepackStatuss();
		//this.getUserInfos();
		//this.getRepackingDetails();
		//this.getControlCards();
		//this.getDeliveryInstructions();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getRepacking(id);
			} else {
				this.modelId = id;
				this.getRepacking(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByRepackingDetail : {
			handler: function() {
				this.getRepackingDetails();
			}
		},
		sortDescRepackingDetail: {
			handler: function() {
				this.getRepackingDetails();
			}
		},
		currentRepackingDetailPage: {
			handler: function() {
				this.getRepackingDetails();
			}
		},
		repackingDetailPageSize : {
			handler: function() {
				this.getRepackingDetails();
			}
		},
		filterRepackingDetail: {
			handler: function() {
				this.getRepackingDetails();
			},
			deep: true,
		},
		sortByRepackingControlCard : {
			handler: function() {
				this.getRepackingControlCards();
			}
		},
		sortDescRepackingControlCard: {
			handler: function() {
				this.getRepackingControlCards();
			}
		},
		currentRepackingControlCardPage: {
			handler: function() {
				this.getRepackingControlCards();
			}
		},
		repackingControlCardPageSize : {
			handler: function() {
				this.getRepackingControlCards();
			}
		},
		filterRepackingControlCard: {
			handler: function() {
				this.getRepackingControlCards();
			},
			deep: true,
		},
	},
}
</script>
